document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-uh]');
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  document.querySelectorAll('[data-uh-search]').forEach((node) => {
    node.classList.remove('is-open');
  });

  // Positioniert ein per position:fixed geöffnetes Dropdown relativ zu
  // seinem Auslöser-Button. Wird auf Mobile gebraucht, weil .uh-right dort
  // overflow-y:hidden hat und ein position:absolute-Dropdown sonst
  // vertikal abgeschnitten/unsichtbar wäre (siehe ks-ultimate-header.css).
  const positionFixedDropdown = (trigger, dropdown) => {
    if (!isMobile()) return;
    const rect = trigger.getBoundingClientRect();
    const gap = 8;
    const maxRight = window.innerWidth - 12;

    dropdown.style.top = `${rect.bottom + gap}px`;

    // rechtsbündig zum Button, aber nie über den Viewport-Rand hinaus
    let left = rect.right - dropdown.offsetWidth;
    if (left < 12) left = 12;
    if (left + dropdown.offsetWidth > maxRight) {
      left = maxRight - dropdown.offsetWidth;
    }
    dropdown.style.left = `${left}px`;
  };

  // ── Länder / Währungs-Dropdowns ────────────────────────────────
  document.querySelectorAll('[data-uh-ddwrap]').forEach((wrap) => {
    const btn  = wrap.querySelector('[data-uh-ddbtn]');
    const list = wrap.querySelector('[data-uh-ddlist]');

    if (!btn || !list) return;

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('[data-uh-ddwrap].is-open').forEach((other) => {
        if (other !== wrap) {
          other.classList.remove('is-open');
          const otherBtn = other.querySelector('[data-uh-ddbtn]');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });

      const willOpen = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        list.style.display = 'flex';
        positionFixedDropdown(btn, list);

        requestAnimationFrame(() => {
          const selected = list.querySelector('.is-selected');
          if (selected) selected.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
      } else if (isMobile()) {
        list.style.display = '';
      }
    });

    list.addEventListener('wheel', (e) => {
      const atTop    = list.scrollTop === 0;
      const atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) e.preventDefault();
      e.stopPropagation();
    }, { passive: false });
  });

  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-uh-ddwrap].is-open').forEach((wrap) => {
      if (!wrap.contains(e.target)) {
        wrap.classList.remove('is-open');
        const btn = wrap.querySelector('[data-uh-ddbtn]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (isMobile()) {
          const list = wrap.querySelector('[data-uh-ddlist]');
          if (list) list.style.display = '';
        }
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-uh-ddwrap].is-open').forEach((wrap) => {
        wrap.classList.remove('is-open');
        const btn = wrap.querySelector('[data-uh-ddbtn]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // ── Land-Auswahl ────────────────────────────────────────────
  document.querySelectorAll('[data-uh-country]').forEach((option) => {
    option.addEventListener('click', () => {
      const form  = option.closest('form');
      if (!form) return;
      const input = form.querySelector('[data-uh-country-input]');
      if (!input) return;
      input.value = option.dataset.uhCountry;
      form.submit();
    });
  });

  // ── Währungs-Auswahl ───────────────────────────────────────────
  document.querySelectorAll('[data-uh-currency]').forEach((option) => {
    option.addEventListener('click', () => {
      const form  = option.closest('form');
      if (!form) return;
      const input = form.querySelector('[data-uh-currency-input]');
      if (!input) return;
      input.value = option.dataset.uhCurrency;
      form.submit();
    });
  });

  // ── Account Dropdown ───────────────────────────────────────────
  if (header) {
    const accountWrap = header.querySelector('[data-uh-account]');
    if (accountWrap) {
      const btn = accountWrap.querySelector('button[aria-controls]');
      const dd  = accountWrap.querySelector('.uh-dd');

      const closeAccount = () => {
        if (!btn || !dd) return;
        dd.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
      };

      const openAccount = () => {
        if (!btn || !dd) return;
        dd.style.display = 'flex';
        btn.setAttribute('aria-expanded', 'true');
        positionFixedDropdown(btn, dd);
      };

      if (btn && dd) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          btn.getAttribute('aria-expanded') === 'true' ? closeAccount() : openAccount();
        });

        document.addEventListener('click', (e) => {
          if (!accountWrap.contains(e.target)) closeAccount();
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') closeAccount();
        });

        window.addEventListener('resize', () => {
          if (btn.getAttribute('aria-expanded') === 'true') positionFixedDropdown(btn, dd);
        });
      }
    }
  }
});
